var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PCNavbar',{attrs:{"selectIndex":3}}),_c('MobileNavBar',{attrs:{"currentActive":3}}),_c('CaseList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }